














































import { defineComponent, onMounted,  Ref, ref, ComputedRef, computed } from '@vue/composition-api';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Endpoints, Mutations } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

import axios from 'axios';

import ChannelListData from '@/ts/Channels/ChannelListData';

export default defineComponent({
    components: {
        SubTitle,
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        channel: ChannelListData,
    }, 
    setup({channel}, context) {

        const store = context.root.$store;

        const channelName: Ref<string> = ref(channel.name);

        const channelDescription: Ref<string> = ref(channel.description);

        const channelTabs: ComputedRef<any> = computed(() => {
        return store.getters['Channels/getChannelsTabs'];
    });

        const handleGoBack = () => {
            const { CHANNEL_INFO } = channelTabs.value;
            context.emit('changeManagementTab', CHANNEL_INFO);
        }

        const onSubmit = async (e) => {
            //@ts-ignore
            const isValid = await context.refs.observer.validate();

            if(isValid) {
                const requestData = new FormData();
                if (channelName.value) { 
                    requestData.append('name', channelName.value); 
                }

                requestData.append('description', channelDescription.value);
                
                axios.put(Endpoints.Admin.Channels.CHANNEL(channel.id), requestData)
                    .then((res) => {
                        if (res && res.data && res.data.data) {
                            const channel = res.data.data;
                            const updatedChannel = new ChannelListData(channel.id, channel.name, channel.description, channel.conversationId, channel.private);
                            context.emit('channelEdited', updatedChannel);
                            handleGoBack();
                        }
                    })
                    .catch((error) => {
                        console.log(error.response);
                        if (error.response && error.response.data && error.response.data.errors) {
                            const errors = error.response.data.errors;
                            if (errors.name && errors.name.length > 0) {
                                /* eslint-disable no-eval */
                                // @ts-ignore
                                context.refs.nameProvider.applyResult({
                                    // @ts-ignore
                                    errors: [ context.root.$t('channels.validation.name-has-been-taken', 'The name has been taken') ],
                                    valid: false,
                                    failedRules: {},
                                });
                                return;
                            }
                        }

                        if (error.response) {
                            const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                            store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                        } else {
                            console.log(error);
                        }
                    });
            }
        }

        onMounted(() => {
        });
        
        return {
            channelDescription,
            channelName,
            handleGoBack,
            onSubmit,
        };
        
    },
});
